module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst meta = (model.documentData || {}).meta || {}\nconst document = meta.document || {}\nconst projectTermRange = meta.projectTermRange || {}\nlet projectTimeRange = utils.moment(projectTermRange.minStartTS).format('DD.MM.YYYY')\nif(projectTermRange.maxStartTS && projectTermRange.minStartTS !== projectTermRange.maxStartTS){\nprojectTimeRange = `${projectTimeRange} - ${utils.moment(projectTermRange.maxStartTS).format('DD.MM.YYYY')}`\n}\nconst projectTitleParts = []\nif(document.projectID)  projectTitleParts.push(`#${document.projectID}`);\nif(document.title)      projectTitleParts.push(document.title);\nconst projectTitle = projectTitleParts.join(' ')\nconst customer = document.customer || {}\nlet customerName = ''\nif(customer.customerID){\ncustomerName = customer.companyName || ''\n}\nconst customerContact = document.customerContact || {}\nlet customerContactName = ''\nif(customerContact.customerContactID){\nconst parts = []\nif(customerContact.title)       parts.push(customerContact.title);\nif(customerContact.firstname)   parts.push(customerContact.firstname);\nif(customerContact.lastname)    parts.push(customerContact.lastname);\nif(parts.length > 0){\ncustomerContactName = parts.join(' ')\n}\n}\nlet customerZipCity = ''\nconst customerZipCityParts = []\nif(customer.zip)    customerZipCityParts.push(customer.zip);\nif(customer.city)   customerZipCityParts.push(customer.city);\ncustomerZipCity = customerZipCityParts.join(' ');\nlet customerContactZipCity = ''\nconst customerContactZipCityParts = []\nif(customerContact.zip)    customerContactZipCityParts.push(customerContact.zip);\nif(customerContact.city)   customerContactZipCityParts.push(customerContact.city);\ncustomerContactZipCity = customerContactZipCityParts.join(' ');\nconst sourceAddressParts = []\nconst fromEmployee = document.fromEmployee || {}\nif(fromEmployee.employeeID){\n// TODO: IMPL\n} else {\nif(model.sourceAddress)                 sourceAddressParts.push(`<div class=\"main\">${String(model.sourceAddress).replace(/\\n/g, '<br>')}</div>`);\nif(model.sourceAddressContact)          sourceAddressParts.push(`<div class=\"contact\">${String(model.sourceAddressContact).replace(/\\n/g, '<br>')}</div>`);\nif(model.sourceAddressMiscellaneous)    sourceAddressParts.push(`<div class=\"miscellaneous\">${String(model.sourceAddressMiscellaneous).replace(/\\n/g, '<br>')}</div>`);\n}\nconst sourceAddress = sourceAddressParts.join('')\nlet targetAddress = ''\nconst targetAddressParts = []\nif(customerName)        targetAddressParts.push(customerName);\nif(customerContactName) targetAddressParts.push(`z.H.: ${customerContactName}`);\nif(customerContact.street){\ntargetAddressParts.push(customerContact.street);\nif(customerContactZipCity)     targetAddressParts.push(customerContactZipCity);\nif(customerContact.country)    targetAddressParts.push(customerContact.country);\n} else {\nif(customer.street)     targetAddressParts.push(customer.street);\nif(customerZipCity)     targetAddressParts.push(customerZipCity);\nif(customer.country)    targetAddressParts.push(customer.country);\n}\nif(customer.companyTaxNumber) targetAddressParts.push(`UID: ${customer.companyTaxNumber}`);\ntargetAddress = targetAddressParts.join('<br>')\nconst projectSubTitleParts = []\nif(projectTitle)                projectSubTitleParts.push(`${storage.__('document.creditNote.projectTitle')}: ${projectTitle}`);\nif(projectTimeRange)            projectSubTitleParts.push(`${storage.__('document.creditNote.timeRange')}: ${projectTimeRange}`);\nconst projectSubTitle = projectSubTitleParts.join('<br>')\nconst customerNumberParts = []\nlet customerNumbers = ''\nif(customer.customerNumber){\ncustomerNumberParts.push(storage.__('document.creditNote.customerNumber', { value: customer.customerNumber }))\n}\nif(document.customerReference){\ncustomerNumberParts.push(document.customerReference)\n}\ncustomerNumbers = customerNumberParts.join('<br>')\nlet documentDate = ''\nif(document.canceledAt){\ndocumentDate = `Wien, am ${utils.moment(document.canceledAt).format('DD. MMMM YYYY')}`\n}\nconst documentNumbers = []\nif(document.canceledNumber){\ndocumentNumbers.push(storage.__('document.creditNote.number', { value: document.canceledNumber }))\n}\nif(document.number){\ndocumentNumbers.push(storage.__('document.invoice.number', { value: document.number }))\n}\n%><div>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n<%- include('./header', { model }) %>\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\"><%- targetAddress %></td>\n<td class=\"sourceAddress\"><%- sourceAddress %></td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\"><%= storage.__('document.creditNote.head') %></td>\n<td class=\"number\"><%- documentNumbers.join('<br>') %></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"subTitle\"><%- projectSubTitle %></td>\n<td class=\"customerNumber\"><%\nif(customerNumbers){\n%><%- customerNumbers %><%\n}\n%></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"documentDate\"><%- documentDate %></td>\n</tr>\n</tbody>\n</table>\n</div>\n<%- helpers.renderSection('content') %>\n</section>\n<%- include('./footer', { model }) %>\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>"
  , __filename = "components/templates/core/documents/creditNote/creditNote.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const meta = (model.documentData || {}).meta || {}
const document = meta.document || {}
const projectTermRange = meta.projectTermRange || {}
let projectTimeRange = utils.moment(projectTermRange.minStartTS).format('DD.MM.YYYY')
if(projectTermRange.maxStartTS && projectTermRange.minStartTS !== projectTermRange.maxStartTS){
projectTimeRange = `${projectTimeRange} - ${utils.moment(projectTermRange.maxStartTS).format('DD.MM.YYYY')}`
}
const projectTitleParts = []
if(document.projectID)  projectTitleParts.push(`#${document.projectID}`);
if(document.title)      projectTitleParts.push(document.title);
const projectTitle = projectTitleParts.join(' ')
const customer = document.customer || {}
let customerName = ''
if(customer.customerID){
customerName = customer.companyName || ''
}
const customerContact = document.customerContact || {}
let customerContactName = ''
if(customerContact.customerContactID){
const parts = []
if(customerContact.title)       parts.push(customerContact.title);
if(customerContact.firstname)   parts.push(customerContact.firstname);
if(customerContact.lastname)    parts.push(customerContact.lastname);
if(parts.length > 0){
customerContactName = parts.join(' ')
}
}
let customerZipCity = ''
const customerZipCityParts = []
if(customer.zip)    customerZipCityParts.push(customer.zip);
if(customer.city)   customerZipCityParts.push(customer.city);
customerZipCity = customerZipCityParts.join(' ');
let customerContactZipCity = ''
const customerContactZipCityParts = []
if(customerContact.zip)    customerContactZipCityParts.push(customerContact.zip);
if(customerContact.city)   customerContactZipCityParts.push(customerContact.city);
customerContactZipCity = customerContactZipCityParts.join(' ');
const sourceAddressParts = []
const fromEmployee = document.fromEmployee || {}
if(fromEmployee.employeeID){
// TODO: IMPL
} else {
if(model.sourceAddress)                 sourceAddressParts.push(`<div class="main">${String(model.sourceAddress).replace(/\n/g, '<br>')}</div>`);
if(model.sourceAddressContact)          sourceAddressParts.push(`<div class="contact">${String(model.sourceAddressContact).replace(/\n/g, '<br>')}</div>`);
if(model.sourceAddressMiscellaneous)    sourceAddressParts.push(`<div class="miscellaneous">${String(model.sourceAddressMiscellaneous).replace(/\n/g, '<br>')}</div>`);
}
const sourceAddress = sourceAddressParts.join('')
let targetAddress = ''
const targetAddressParts = []
if(customerName)        targetAddressParts.push(customerName);
if(customerContactName) targetAddressParts.push(`z.H.: ${customerContactName}`);
if(customerContact.street){
targetAddressParts.push(customerContact.street);
if(customerContactZipCity)     targetAddressParts.push(customerContactZipCity);
if(customerContact.country)    targetAddressParts.push(customerContact.country);
} else {
if(customer.street)     targetAddressParts.push(customer.street);
if(customerZipCity)     targetAddressParts.push(customerZipCity);
if(customer.country)    targetAddressParts.push(customer.country);
}
if(customer.companyTaxNumber) targetAddressParts.push(`UID: ${customer.companyTaxNumber}`);
targetAddress = targetAddressParts.join('<br>')
const projectSubTitleParts = []
if(projectTitle)                projectSubTitleParts.push(`${storage.__('document.creditNote.projectTitle')}: ${projectTitle}`);
if(projectTimeRange)            projectSubTitleParts.push(`${storage.__('document.creditNote.timeRange')}: ${projectTimeRange}`);
const projectSubTitle = projectSubTitleParts.join('<br>')
const customerNumberParts = []
let customerNumbers = ''
if(customer.customerNumber){
customerNumberParts.push(storage.__('document.creditNote.customerNumber', { value: customer.customerNumber }))
}
if(document.customerReference){
customerNumberParts.push(document.customerReference)
}
customerNumbers = customerNumberParts.join('<br>')
let documentDate = ''
if(document.canceledAt){
documentDate = `Wien, am ${utils.moment(document.canceledAt).format('DD. MMMM YYYY')}`
}
const documentNumbers = []
if(document.canceledNumber){
documentNumbers.push(storage.__('document.creditNote.number', { value: document.canceledNumber }))
}
if(document.number){
documentNumbers.push(storage.__('document.invoice.number', { value: document.number }))
}

    ; __line = 88
    ; __append("<div>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n")
    ; __line = 93
    ; __append( include('./header', { model }) )
    ; __append("\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\">")
    ; __line = 99
    ; __append( targetAddress )
    ; __append("</td>\n<td class=\"sourceAddress\">")
    ; __line = 100
    ; __append( sourceAddress )
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\">")
    ; __line = 105
    ; __append(escapeFn( storage.__('document.creditNote.head') ))
    ; __append("</td>\n<td class=\"number\">")
    ; __line = 106
    ; __append( documentNumbers.join('<br>') )
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"subTitle\">")
    ; __line = 111
    ; __append( projectSubTitle )
    ; __append("</td>\n<td class=\"customerNumber\">")
    ; __line = 112
    ; 
if(customerNumbers){

    ; __line = 114
    ; __append( customerNumbers )
    ; 
}

    ; __line = 116
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"documentDate\">")
    ; __line = 126
    ; __append( documentDate )
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n</div>\n")
    ; __line = 131
    ; __append( helpers.renderSection('content') )
    ; __append("\n</section>\n")
    ; __line = 133
    ; __append( include('./footer', { model }) )
    ; __append("\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>")
    ; __line = 138
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/creditNote/creditNote.ejs

}